export const IVR_API_URL =
  "https://promo.share.market/json/ivr-config.json";
